import {config} from "../constants";
import {AuthService} from "../../screens/auth/service/auth-service";

const BASE = config.genericService + "/projects";

const authFetch = async (url, opts = {}) => {
    const token = await AuthService.getIdTokenOfCurrentUser();
    if (!token) return null;
    return fetch(url, {
        ...opts,
        headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', ...opts.headers },
        mode: 'cors',
    }).then(r => r.json()).catch(() => null);
};

export class ProjectsService {
    getProjects = () => authFetch(BASE);
    createProject = (data) => authFetch(BASE, { method: 'POST', body: JSON.stringify(data) });
    getProjectContents = (id) => authFetch(BASE + "/" + encodeURIComponent(id));
    updateProject = (id, data) => authFetch(BASE + "/" + id, { method: 'PUT', body: JSON.stringify(data) });
    deleteProject = (id) => authFetch(BASE + "/" + id, { method: 'DELETE' });
    assignFindoc = (findocId, projectId) => authFetch(BASE + "/findoc/" + findocId, { method: 'PUT', body: JSON.stringify({ projectId }) });
    assignReceipt = (receiptId, projectId) => authFetch(BASE + "/receipt/" + receiptId, { method: 'PUT', body: JSON.stringify({ projectId }) });
}
